import helpers from './helpers';
import cursor from './components/cursor';
import mainAnimation from './components/main-animation';
import scrollbar from './components/scrollbar';

function init() {
	helpers.scrollTo(helpers.$body);
	mainAnimation.init();
	scrollbar.init();
	cursor.init();

	const element = document.querySelector('.main__containerImg');

	// eslint-disable-next-line no-unused-vars
	const wave = new Wave().init(element, 1);
}

// if ($('.main').length) {
// 	init();
// } else {
// 	// scrollbar.init();
// }

if ($('.main__scrollBar').length) {
	scrollbar.init();
}
